import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@app/ui';

function CrashedComponent({ onReload, canReload }) {
    return (
        <div
            className="gds-flex gds-flex--content-center gds-flex--justify-center gds-flex--direction-col gds-flex--align-center -pos-rel -p-v-4"
            style={{ width: '100%', height: '100%' }}
        >
            <div className="gds-flex__item gds-flex__item--grow-0 gds-text--header-lg -text-center -m-b-1 -color-tx-gold">
                <i className="fas fa-exclamation-triangle -m-h-1" />
            </div>
            <div className="gds-flex__item gds-flex__item--grow-0 gds-text--header-xs -text-center">
                Component Loading Error
            </div>
            {canReload && (
                <div className="gds-flex__item gds-flex__item--grow-0 -text-center -m-t-3">
                    <Button size="small" variant="primary" onClick={onReload}>
                        Reload
                    </Button>
                </div>
            )}
        </div>
    );
}

CrashedComponent.propTypes = {
    onReload: PropTypes.func.isRequired,
    canReload: PropTypes.bool.isRequired,
};

export default CrashedComponent;
